import { Input } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Switch from 'components/switch';
import React from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ProjectedPaymentsForm } from '../services';

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    '& .MuiFormControlLabel-label': { marginLeft: theme.spacing(2) },
    '& .MuiSwitch-root:has(.MuiSwitch-switchBase.Mui-focusVisible)': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 0,
      borderRadius: 19,
    },
    '@media (hover: none) and (pointer: coarse)': { minHeight: 44, '& .MuiFormControlLabel-root': { minHeight: 44 } },
  },
  addDescField: {
    marginLeft: theme.spacing(3),
    '&>*': {
      height: theme.spacing(4),
      width: theme.spacing(30),
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      width: '100%',
      minWidth: 0,
      '&>*': { width: '100%' },
    },
    '@media (hover: none) and (pointer: coarse)': { '&>*': { minHeight: 44 } },
  },
  underline: {
    fontSize: theme.spacing(2),
    color: theme.palette.primary.light,
    fontWeight: 500,
    width: '100%',
    paddingLeft: theme.spacing(1),
    '&&&:before': { borderBottom: 'none' },
    '&&:after': { borderBottom: 'none' },
    '&:hover': { background: theme.palette.input.border },
  },
}));

type IncludesFieldsType = {
  methods: UseFormReturn<ProjectedPaymentsForm>
}

const IncludesFields = ({
  methods
}: IncludesFieldsType) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <>
      <span className={classes.root}>
        <Controller
          control={methods.control}
          name="includes_taxes"
          render={({ field }) => (
            <>
              <Switch
                label={t('projectedPayments:propertiesTaxes')}
                checked={field.value}
                handleOnChange={(e) => field.onChange(e.target.checked)}
              />
            </>
          )}
        />
      </span>

      <span className={classes.root}>
        <Controller
          control={methods.control}
          name="includes_homeowners"
          render={({ field }) => (
            <>
              <Switch
                label={t('projectedPayments:homeownersInsurance')}
                checked={field.value}
                handleOnChange={(e) => field.onChange(e.target.checked)}
              />
            </>
          )}
        />
      </span>

      <span className={classes.root}>
        <Controller
          control={methods.control}
          name="includes_other"
          render={({ field }) => (
            <>
              <Switch
                label={t('projectedPayments:other')}
                checked={field.value}
                handleOnChange={(e) => field.onChange(e.target.checked)}
              />
            </>)}
        />
      </span>
      <span className={classes.addDescField}>
        <Controller
          control={methods.control}
          name="other_description"
          render={({ field }) => (
            <>
              <Input
                className={classes.underline}
                placeholder={t('projectedPayments:addADescription')}
                inputProps={{ 'aria-label': t('projectedPayments:addADescription') }}
                value={field.value}
                onChange={(e) => field.onChange(e.target.value)}
              />
            </>)}
        />
      </span>
    </>
  );
};

export default IncludesFields;
